import { render, staticRenderFns } from "./custom-event-without-order.vue?vue&type=template&id=7123d1bb"
import script from "./custom-event-without-order.vue?vue&type=script&lang=js"
export * from "./custom-event-without-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports